module.exports = __webpack_public_path__ + "img/icon-export.0dfb9f09.svg";